import { omitBy } from 'lodash';

export const userPhaseProgressWeightMap = {
  NEW: 1,
  'ON TRACK': 2,
  'AT RISK': 3,
  'OFF TRACK': 4,
};

export const MEETING_TYPES_SELECT_OPTIONS = [
  { label: 'Check In', value: 'check in' },
  { label: 'Intake', value: 'intake' },
  { label: 'Diet Modifications', value: 'diet modifications' },
  { label: 'Mind Gut', value: 'mind gut' },
  { label: 'Phase 1', value: 'phase 1' },
  { label: 'Phase 2', value: 'phase 2' },
  { label: 'Phase 3', value: 'phase 3' },
  { label: 'Phase 4', value: 'phase 4' },
  { label: 'Final Nutrition', value: 'final nutrition' },
];

export const toTitleCase = (str) =>
  str
    .toLowerCase()
    .split(' ')
    .map((word) => word.replace(word[0], word[0].toUpperCase()))
    .join(' ');

export const countDecimals = (number) => {
  const converted = number.toString();
  if (converted.includes('.')) return converted.split('.')[1].length;
  return 0;
};

export const buildDefaultMeeting = (user_id) => ({
  user_id,
  meeting_date: '',
  meeting_type: 'Phase 1',
  meeting_duration: '30',
  notes_url: '',
  highlights: [],
  notes: '',
});

export const cleanMeetingNotes = (meeting) => omitBy(meeting, (f) => !f);
